import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router, RouterLinkActive, RouterLink } from "@angular/router";
import { mappingRoutes } from "../../core/mappingRoutes";
import { NzWaveModule } from "ng-zorro-antd/core/wave";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NgFor, NgIf } from "@angular/common";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { Subscription } from "rxjs";
import { TenantContextService } from "src/app/services/tenant-context.service";

@Component({
    selector: "sidebar-cmp",
    templateUrl: "sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    imports: [
        NzMenuModule,
        NgFor,
        NgIf,
        NzButtonModule,
        RouterLinkActive,
        RouterLink,
        NzIconModule,
        NzWaveModule,
    ]
})
export class SidebarComponent implements OnInit, OnDestroy {
  menuItems: any[] = [];
  @Input("routeMenu") ROUTE_MENU: any[] = [];

  private currentRole: "SYSTEM" | "SUPER" | "AGENT" | null = null;
  private _sub = new Subscription();

  constructor(
    private router: Router,
    private tenantContext: TenantContextService
  ) {}

  ngOnInit() {
    // Filtre les entrées de menu par rôle système.
    //   - Une entrée sans `requiredSystemRoles` est visible à tous (par défaut)
    //   - Une entrée avec `requiredSystemRoles: ["SYSTEM"]` n'est visible qu'aux SystemAdmin
    //   - Cf. dashboard-routes.routes.ts pour les déclarations
    this._sub.add(
      this.tenantContext.systemRole$.subscribe((role) => {
        this.currentRole = role;
        this.menuItems = this.filterByRole(this.ROUTE_MENU);
      })
    );
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  private filterByRole(menu: any[]): any[] {
    return (menu || [])
      .filter((m) => m && this.canSee(m))
      .map((m) => {
        if (Array.isArray(m.children) && m.children.length > 0) {
          return { ...m, children: this.filterByRole(m.children) };
        }
        return m;
      });
  }

  private canSee(menuItem: any): boolean {
    const required: string[] | undefined = menuItem.requiredSystemRoles;
    if (!required || required.length === 0) return true;
    if (!this.currentRole) return false;
    return required.includes(this.currentRole);
  }

  public activatedLinkChecker = (link: string): boolean =>
    this.router.url.includes(link);

  redirecToIndex() {
    this.router.navigate([this.ROUTE_MENU[0]["path"]]);
  }

  goArchive() {
    this.router.navigate([mappingRoutes.archives]);
  }
}
